// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"b26340ab","423":"26ebda44","453":"d31fdf58","977":"35a39907"}[chunkId] + ".chunk.js";
};